import { formatDateGregorian, formatDateTimeGregorian } from './modules/dateFilters.js'


export default {
	install(Vue) {

		Vue.filter('formatDateGregorian', formatDateGregorian)

		Vue.filter('formatDateTimeGregorian', formatDateTimeGregorian)

	},
}